import { Box } from "@mui/material";
import { AuthProvider } from "@ssf/auth-components";
import { AppWrapper, Footer, Page, queryClient, theme } from "@ssf/components";
import { setAuthorization as setMemdbAuthorization } from "@ssf/memdb-api";
import { ClubWebLinkProvider } from "@ssf/memdb-components";
import { QueryClientProvider } from "@tanstack/react-query";

import { Header, Router } from "./components/index.js";
import { i18next } from "./lib/index.js";

const CLUB_WEB_URL = process.env.CLUB_WEB_URL;
if (!CLUB_WEB_URL) {
  throw new Error("env `CLUB_WEB_URL` is not set");
}

export const App = () => (
  <AppWrapper theme={theme} i18n={i18next}>
    <ClubWebLinkProvider clubWebUrl={CLUB_WEB_URL} isS4>
      <QueryClientProvider client={queryClient}>
        <AuthProvider
          signinRedirectArgs={{ extraQueryParams: { createAccount: true } }}
          onUser={(user) => {
            setMemdbAuthorization(user?.access_token);
          }}
        >
          <Page>
            <Header />
            <Box sx={{ flex: "1 0 auto", position: "relative" }}>
              <Router />
            </Box>
            <Footer />
          </Page>
        </AuthProvider>
      </QueryClientProvider>
    </ClubWebLinkProvider>
  </AppWrapper>
);
